import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ContactsService {
	private readonly contactsUrl = environment.main_url + '/agilelegal/contacts';

	constructor(private readonly http: HttpClient) {}

	getContacts(pageNumber: number, pageSize: number, payload: any) {
		return this.http.post<any>(
			`${this.contactsUrl}/filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,
			payload
		);
	}
}
